import { lazy } from "react";

const UiMARCodeAvailabilityOverlay = lazy(
  () => import("./uiMARCodeAvailabilityOverlay/UiMARCodeAvailabilityOverlay"),
);
const UiMBannerCMESummary = lazy(
  () => import("./uiMBannerCMESummary/UiMBannerCMESummary"),
);
const UiMButtonAR = lazy(() => import("./uiMButtonAR/UiMButtonAR"));
const UiMButtonContactDealer = lazy(
  () => import("./uiMButtonContactDealer/UiMButtonContactDealer"),
);
const UiMButtonRepayment = lazy(() => import("./uiMButtonRepayment/UiMButtonRepayment"));
const UiMCMECopyLink = lazy(() => import("./uiMCMECopyLink/UiMCMECopyLink"));
const UiMCMEImage = lazy(() => import("./uiMCMEImage/UiMCMEImage"));
const UiMCMEQtvr = lazy(() => import("./uiMCMEQtvr/UiMCMEQtvr"));
const UiMCMERcrVideo = lazy(() => import("./uiMCMERcrVideo/UiMCMERcrVideo"));
const UiMCMESpinner = lazy(() => import("./uiMCMESpinner/UiMCMESpinner"));
const UiMConfigurator = lazy(() => import("./uiMConfigurator/UiMConfigurator"));
const UiMModalDefault = lazy(() => import("./uiMModalOverlay/UiMModalOverlay"));
const UiMPricing = lazy(() => import("./uiMPricing/UiMPricing"));
const UiMPricingLarge = lazy(() => import("./uiMPricingLarge/UiMPricingLarge"));
const UiMPrintPDF = lazy(() => import("./uiMPrintPDF/UiMPrintPDF"));
const UiMQRCodeOverlay = lazy(() => import("./uiMQRCodeOverlay/UiMQRCodeOverlay"));
const UiMRoadMapCards = lazy(() => import("./uiMRoadMapCards/UiMRoadMapCards"));
const UiMShareFlyout = lazy(() => import("./uiMShareFlyout/UiMShareFlyout"));
const UiMSpecifications = lazy(() => import("./uiMSpecifications/UiMSpecifications"));
const UiMSpecificationsList = lazy(
  () => import("./uiMSpecificationsList/UiMSpecificationsList"),
);
const UiMVehicleSelector = lazy(() => import("./uiMVehicleSelector/UiMVehicleSelector"));
const UiMUsabilla = lazy(() => import("./uiMUsabilla/UiMUsabilla"));

export { default as UiMMenuSticky } from "./uiMMenuSticky/UiMMenuSticky";
export { default as UiMGazooRacing } from "./uiMGazooRacing/UiMGazooRacing";

export {
  UiMARCodeAvailabilityOverlay,
  UiMBannerCMESummary,
  UiMButtonAR,
  UiMButtonContactDealer,
  UiMButtonRepayment,
  UiMCMECopyLink,
  UiMCMEImage,
  UiMCMEQtvr,
  UiMCMERcrVideo,
  UiMCMESpinner,
  UiMConfigurator,
  UiMModalDefault,
  UiMPricing,
  UiMPricingLarge,
  UiMPrintPDF,
  UiMQRCodeOverlay,
  UiMRoadMapCards,
  UiMShareFlyout,
  UiMSpecifications,
  UiMSpecificationsList,
  UiMVehicleSelector,
  UiMUsabilla,
};
